import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-bill-picture',
  templateUrl: './bill-picture.component.html',
  styleUrls: ['./bill-picture.component.scss'],
})
export class BillPictureComponent {
  @Input() url: string | undefined;
  @Input() isLoading = false;
  @Input() placeHolder!: string;
  @Output() onChoose = new EventEmitter();
}
